<template>
  <div class="StockHistory">
    <div class="page-title">자재 재고 변동 이력</div>
    <ATable
      v-loading="loading"
      ref="table"
      max-height="700px"
      buttons-width="250px"
      hide-pagination
      hide-button-insert
      highlight-current-row
      border
      :data="items"
      @row-click="handleClickRow"
    >
      <div slot="search">
        <div class="flex">
          <div class="flex title-wrapper">
            <span class="title">품목:</span>
            <el-input
              v-if="piece_productname"
              v-model="searchWord"
              class="ml-default"
              size="mini"
              placeholder="품목번호, 품목명"
            ></el-input>
            <AProductSelector
              v-else
              class="ml-default"
              :value="data ? data.product_name : ''"
              @select="handleSelectProduct"
            />
          </div>
          <!-- <span class="text ml-default">{{
            data ? data.product_name : ""
          }}</span> -->
          <div class="inline ml-default">
            <APeriodSelector
              ref="period"
              v-model="searchPeriod"
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >{{ $t("button.search") }}(F5)</el-button
            >
          </div>
          <div class="inline ml-default">
            <el-checkbox v-model="piece_productname">일부 품목명</el-checkbox>
          </div>
        </div>
      </div>
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.index"
      />
      <el-table-column prop="product_name" label="품목" width="200" />
      <el-table-column label="단위" width="60" :formatter="resolveUnit" />
      <el-table-column prop="size" label="규격" width="80" />
      <el-table-column
        prop="inbound"
        label="입고수량"
        width="150"
        :formatter="util.numberFormat"
        class-name="cell-number"
      />
      <el-table-column
        prop="outbound"
        label="출하수량"
        width="150"
        :formatter="util.numberFormat"
        class-name="cell-number"
      />
      <el-table-column
        prop="current"
        label="현재수량"
        width="150"
        :formatter="resolveCurrent"
        class-name="cell-number"
      />
      <el-table-column label="구분" width="100" :formatter="resolveType" />
      <el-table-column label="구분코드" width="100"  :formatter="codeType" />
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="deal_date"
        label="거래일"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="created_at"
        label="변경일"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column prop="desc" label="비고" show-overflow-tooltip />
      <div slot="buttons">
        <el-button :disabled="!has_grant_write" @click="handleClickModify"
          >수정</el-button
        >
        <el-button
          type="danger"
          :disabled="!has_grant_write"
          @click="handleClickDelete"
          >삭제</el-button
        >
        <!-- <el-button
          type="primary"
          v-if="isShowBtnSetBreak === true"
          :disabled="!has_grant_write"
          @click="handleClickSetBreak"
          >세트 분리 등록</el-button
        > -->
        <el-button
          type="primary"
          :disabled="!has_grant_write"
          @click="handleClickSetBreak"
          >세트 분리 등록</el-button
        >
      </div>
    </ATable>
    <el-dialog
      :title="dialog_title"
      top="0"
      custom-class="form-dialog stock2-dialog"
      destroyOnClose
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
    >
      <StockForm
        ref="form"
        :data="isUpdate ? selectedData : data"
        :isUpdate="isUpdate"
        :isSetBreak="isSetBreak"
        @completed="handleCompletedForm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { authority_level } from "@/common/mixins/authority_level";
import moment from "moment";
import StockForm from "./StockForm";

export default {
  name: "StockHistory",
  mixins: [authority_level],
  components: { StockForm },
  data() {
    return {
      data: undefined,
      searchPeriod: "0d",
      period: null,
      loading: false,
      items: [],
      showDelete: false,
      selectedData: null,
      dialog_visible: false,
      isUpdate: true,
      isSetBreak: false,
      // isShowBtnSetBreak: false,
      dialog_title: "수정",
      searchWord: "",
      piece_productname: true,
    };
  },
  watch: {
    data() {
      this.selectedData = null;
      // this.loadData();
    },
  },
  mounted() {
    // this.$nextTick(() => this.loadData());
  },
  computed: {
    ...mapGetters(["table_product", "table_unit"]),
    has_grant_write() {
      return this.isWriteLevel("stock_history");
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      this.showButton = false;

      // if (this.data) {
      //   let product = this.table_product.find(
      //     (p) => p.id === this.data.product_id
      //   );
      //   if (product.bom_flag === "Y") this.isShowBtnSetBreak = true;
      //   else this.isShowBtnSetBreak = false;
      // }
      let param = Object.assign({}, this.period);
      if (this.piece_productname) {
        param.product_id = this.searchWord === "" ? null : this.searchWord;
      } else {
        param.product_id = this.data ? this.data.product_id : 0;
      }
      param.piece_productname = this.piece_productname ? "Y" : "N";

      this.api.listStock(param).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "자재", res.message);
          return;
        }
        this.items = res.data;
      });
    },
    doDelete() {
      this.api.deleteStcok(this.selectedData).then((res) => {
        if (res.error !== this.system.noError) {
          this.loading = false;
          this.util.notify_error(this, "자재", res.message);
          return;
        }
        this.showDelete = false;
        this.loadData();
        this.$emit("change");
      });
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCurrentChange(data) {
      this.showDelete = false;
      data = data[0];
      if (this.items[0].id !== data.id) {
        return;
      }
      if (
        data.inbound_id ||
        data.contract_detail_id ||
        data.production_id ||
        data.failure_id
      ) {
        return;
      }
      let hours = moment(data.created_at).diff(moment(), "hours");
      if (hours > 23) {
        return;
      }
      this.showDelete = true;
      this.selectedData = data;
    },
    handleClickModify() {
      if (!this.selectedData) {
        this.util.notify_error(
          this,
          "자재",
          "수정할 자재 재고 변동 이력을 선택하세요."
        );
        return;
      }
      if (this.resolveType(this.selectedData) !== "수동") {
        this.util.notify_error(
          this,
          "자재",
          "구분 항목에서 수동 타입인 자재 재고만 수정할 수 있습니다."
        );
        return;
      }
      this.isUpdate = true;
      this.isSetBreak = false;

      this.dialog_title = "수정";
      this.dialog_visible = true;
    },
    handleClickDelete() {
      if (!this.selectedData) {
        this.util.notify_error(
          this,
          "자재",
          "삭제할 자재 재고 변동 이력을 선택하세요."
        );
        return;
      }
      this.util.confirm_delete(this, "자재", this.doDelete);
    },
    resolveType(data) {
      if (data.production_id) {
        return "생산";
      } else if (data.contract_detail_id) {
        return "출하";
      } else if (data.failure_id) {
        return "불량";
      } else if (data.inbound_id) {
        return "매입";
      } else if (data.sale_id) {
        return "매출";
      } else {
        return "수동";
      }
    },
    codeType(data) {
      if (data.contract_code) {
        return data.contract_code;
      } else if (data.inbound_code) {
        return data.inbound_code;
      } else if (data.production_code) {
        return data.production_code
      } else {
        return "";
      }
    },
    resolveUnit(data) {
      let u = this.table_unit.find((u) => u.id === data.unit_id);
      return u ? u.name : "";
    },
    resolveCurrent(data) {
      // let p = this.table_product.find((p) => p.id === data.product_id);
      let u = this.table_unit.find((u) => u.id === data.unit_id);
      let value = data.current;
      if (u.multiply) {
        value = value / u.multiply;
      }
      return this.util.addComma(value) + " " + u.name;
    },
    handleClickRow(data) {
      this.selectedData = data;
      let p = this.table_product.find((p) => p.id === data.product_id);
      this.selectedData.product_name = p.name;
    },
    handleCompletedForm(data) {
      this.dialog_visible = false;
      if (!data) {
        return;
      }
      this.loadData();
      this.$emit("change");
    },
    handleClickSetBreak() {
      if (this.working) {
        this.showExcelWorkingMsg();
        return;
      }
      this.isUpdate = false;
      this.isSetBreak = true;

      this.dialog_title = "재고 세트 분리 등록";
      this.dialog_visible = true;
    },
    handleSelectProduct(product) {
      if (!product || typeof product === "string") {
        this.data = undefined;
      } else {
        this.data = {
          product_id: product.id,
          product_name: product.name,
          size: product.size,
        };
      }
    },
  },
};
</script>

<style>
.stock-dialog {
  width: 220px;
}
.stock2-dialog {
  width: 440px;
}
</style>
<style lang="scss" scoped>
.title-wrapper {
  width: 300px;
}
.title {
  font-weight: bold;
  min-width: 30px;
}
.text {
  min-width: 60px;
  display: inline-block;
}
</style>
